// This file is generated by the openedx/frontend-platform's "intl-import.js" script.
//
// Refer to the i18n documents in https://docs.openedx.org/en/latest/developers/references/i18n.html to update
// the file and use the Micro-frontend i18n pattern in new repositories.
//

import messagesFromFrontendPlatform from './messages/frontend-platform';
import messagesFromParagon from './messages/paragon';
import messagesFromFrontendAppAuthn from './messages/frontend-app-authn';

export default [
  messagesFromFrontendPlatform,
  messagesFromParagon,
  messagesFromFrontendAppAuthn,
];
